import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Swiper from 'swiper';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { AlertsService } from 'src/app/services/alerts/alerts.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { ProductsService } from 'src/app/services/products/products.service';
import { PromotionsService } from 'src/app/services/promotions/promotions.service';
import { StoresService } from 'src/app/services/stores/stores.service';
import { FavoritosService } from 'src/app/services/favorites/favorites';
import { Subscription } from 'rxjs';
import {NavigationEnd, Router } from '@angular/router';

import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { CartModalComponent } from '../../components/cartModal/cart-modal/cart-modal.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { productHasAnySellableStock } from 'src/app/utils/product-stock.util';


@Component({
  selector: 'app-carousel-slider',
  templateUrl: './carousel-slider.component.html',
  styleUrls: ['./carousel-slider.component.scss']
})
export class CarouselSliderComponent implements OnInit {

  @Input() products: any[] = [];
  @Input() type: string = '';
  /** When true, out-of-stock strip uses short `alerts.noStock` (listing pages). Detail / other contexts should omit or set false. */
  @Input() listingShortOutOfStockCopy = false;
  id_store_current: string = 'rednumbers';
  promoActive: boolean = false;
  public promotionInfo : any = [];
  @ViewChild(SwiperDirective, { static: false }) directiveRef?: SwiperDirective;

  // default
  public swiperDefaultConfig: SwiperConfigInterface = {};
  // coverflow effect
  public swiperAutoplayConfig: SwiperConfigInterface = {
    spaceBetween: 0,
    centeredSlides: true,
    slidesPerView: 1,
    speed: 3000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-paginationBest',
      clickable: true,
      type: 'bullets',
    },
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    // puntos responsive
    /*breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
      }
      },*/
      // FIN puntos responsive
  };

indexProdActiveN:number = 0
// scroll horizontal effect
public swiperAutoplayConfig2: SwiperConfigInterface = {
  spaceBetween: 20,
  centeredSlides: false,
  slidesPerView: 1,
  speed: 2000,
  autoplay: {
    delay: 2500,
    disableOnInteraction: true,
  },
  /*pagination: {
    el: '.swiper-pagination.swiper2',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next.swiper2',
    prevEl: '.swiper-button-prev.swiper2',
  },*/
  // puntos responsive
  breakpoints: {
    320: {
      slidesPerView: 1.5,
      spaceBetween: 20,
      centeredSlides: true,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1535: {
      slidesPerView: 6,
      spaceBetween: 30,
    }
    },
    // FIN puntos responsive
};

public swiperAutoplayConfig3: SwiperConfigInterface= {
  spaceBetween: 20,
  centeredSlides: false,
  slidesPerView: 1,
  speed: 2000,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // puntos responsive
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1535: {
      slidesPerView: 6,
      spaceBetween: 30,
    }
    },
};
  public swiperThumbsConfig: SwiperConfigInterface = {
    spaceBetween: 30,
    centeredSlides: true,
    slideToClickedSlide: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: {
        el: '.gallery-thumbs',
        slidesPerView: 5,
      },
      // multipleActiveThumbs: true
    },
  };

  tag:object = null

  default_image : string = "https://puu.sh/ImNRs/0ab1b352dc.png";


  productsFavorites:any[] = []
  isInFav:boolean = false
  private subscriptions: Array<Subscription> = [];
  
  logoProduct:any[] = [];



  buyNow:boolean = false
  images:any[] = []
  current_product : any = {}
  cantidad:number = 1
  product: any = {};
  cart:any[] = []




  tagsList : any = [];



  constructor(
    private stores: StoresService,
    private spinner: NgxSpinnerService,
    private cartService: CartService,
    private router: Router,
    private PromotionsServices: PromotionsService,
    private productService: ProductsService,
    private alerts: AlertsService,
    private checkoutService: CheckoutService,
    private translate: TranslateService,
    private modalService: ModalService<CartModalComponent>,
    private favoritosService: FavoritosService

    ) { 
      this.subscriptions.push(
        router.events.subscribe((val) => val instanceof NavigationEnd && this.getFavorites())
      )
      this.getId() 
    }

  ngOnInit(): void {

    this.getPromos()
    if(this.products.length >0 ){
      this.products = this.products.map(prod=>{
        //valor por defecto
        let nameProduct = prod.name

        if(prod.variants[0].tags.length > 0){
         prod.variants[0].tags.map(tagItem=>{
            this.tagsList.push(tagItem.tag.name)
          })
        }

        //si tiene variante tomo el name de la primer variante porque no tiene un name directamente
        if(prod.variants.length > 0){
          if(prod.name == null || prod.name == undefined){
            nameProduct = prod.variants[0].name
          }
          let {tags} = prod.variants[0]
          if(tags){
            this.tag = tags[0]
          }


          if(prod.variants.length > 0){
            let toppings = prod.variants[0].toppings
            if(toppings.length > 0){
              let {topping } = toppings[0]
              if(topping.length > 0){
                this.logoProduct[prod.product] = topping[0].image
              }
            }
          }
        }
        //reemplazo los caracteres que no se usan
        prod.slugName = nameProduct.replace(/-/g,'_') //reemplazo guion por _
                        .replace(/\s-\s/g,'-_-') //reemplazo guion con espacio de cada lado por _
                        .replace(/\s/g, '-') //reemplazo espacio en blanco por guion
                        .replace(/\+/g,'¬') // reemplazo + por ¬ 
                        .replace(/\//g,'\\') // reemplazo / por \
        return prod
      })
    }

  }

  ngOnDestroy(){
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }


  getFavorites(){
    this.subscriptions.push(
      this.favoritosService.getProductFavorites().subscribe(list => {
          this.productsFavorites = list
      })
    )
    }


  getId(){
    this.stores.getStoreId()
    .subscribe(id => id !== null && id !== "null" ? this.id_store_current = id : null )
  }
  eventDispatcher(event){
    this.indexProdActiveN = event
  }

  productListingInStock(product: any): boolean {
    return productHasAnySellableStock(product);
  }

  activeHeroInStock(): boolean {
    const p = this.products[this.indexProdActiveN];
    return productHasAnySellableStock(p);
  }

  get outOfStockCopyKey(): string {
    return this.listingShortOutOfStockCopy ? 'alerts.noStock' : 'alerts.noStockAvailable';
  }

  redirect(product:any) {
    if(product.slugName != undefined){
      this.router.navigate([`/${this.id_store_current}/product/${product.slugName}`])
    }else{
      let nameProduct = product.name
      //si tiene variante tomo el name de la primer variante porque no tiene un name directamente
      if(product.variants.length > 0 && product.name == null || product.name == undefined){
        nameProduct = product.variants[0].name
      }
      let slugName = nameProduct.replace(/-/g,'_') //reemplazo guion por _
      .replace(/\s-\s/g,'-_-') //reemplazo guion con espacio de cada lado por _
      .replace(/\s/g, '-') //reemplazo espacio en blanco por guion
      .replace(/\+/g,'¬') // reemplazo + por ¬ 
      .replace(/\//g,'\\') // reemplazo / por \
      this.router.navigate([`/${this.id_store_current}/product/${slugName}`])

    }
    
  }



  addOrRemoveFavorite(producto){
    // console.log(producto)
    let {product_sku,name,subtitle,images} = producto.variants[0]
    let dataProduct = {
                        id: product_sku,
                        nombre: name,
                        images,
                        subtitle
                      }
    this.favoritosService.setProductFavorites(dataProduct)
    this.checkFavorites(producto)
  }

  checkFavorites(product){
    this.productsFavorites = this.favoritosService.obtenerFavoritos()
    let productToFind = product.variants[0]
    productToFind.id = productToFind.product_sku
    this.isInFav = this.favoritosService.productoEstaEnFavoritos(productToFind,this.productsFavorites)
  }

  getIsInFav(product){
      let isInFavoritos =  false
      if(product.variants.length > 0){
        let productToFind = product.variants[0]
        productToFind.id = productToFind.product_sku
        isInFavoritos = this.favoritosService.productoEstaEnFavoritos(productToFind,this.productsFavorites)
      }
      return isInFavoritos
  }

  async getPromos(){
    this.products.forEach(async product => {
      this.PromotionsServices.getPromotion().subscribe((promotion : any) => {
      this.PromotionsServices.getPromotion()
      if(promotion){
        this.promotionInfo = promotion;
        if(this.promotionInfo&&this.promotionInfo!=false && (this.promotionInfo.type=='004' || this.promotionInfo.type=='002' || this.promotionInfo.type=='005' )){
          this.PromotionsServices.isProductInPromotion(this.id_store_current,product.sku).then((res2) => {
            if (res2.state == "success") {
                if(res2.data.length!=0){
                  product.promoActive = true;
                    }else{
                      product.promoActive = false;
                    }
                  }else{
                    product.promoActive = false;
                }
          }).catch((error) => {
              product.promoActive = false;
            });
       }
      }
    });
    })
  }




  async addItemTocart(producto) {
    this.current_product = producto.variants[0]
    this.product = producto.variants


    let noStock = false
    let carrito = []
    this.cartService.getCart().subscribe(cart => carrito = cart)
    carrito.map(item=> {
      if( item.product.product == this.current_product.product ){
        if(item.variation.quantity + this.cantidad > this.current_product.stock){
          noStock = true
        }
      }
    })
    if(noStock){
      this.alerts.alertError(this.translate.instant('alerts.noStockAvailable'))
      return
    }else{
      this.addToCart() 
    }
  }

  async addToCart() {
    let exist = false;
    this.product = this.product.map(item=>{
      this.images.map(img => {
        item.images.push(img)
      })
      return item
    })
    
    for (var i = 0; i < this.cart.length; i++) {
      if (this.cart[i].variation.product_sku == this.current_product.product_sku) {
        if ((this.cart[i].variation.quantity + 1) <= this.current_product.stock) {
          exist = true;
          this.cartService.addItemTocart(this.product, this.current_product, this.cantidad);
          if(!this.buyNow){
            this.alerts.alertToastCenter(this.translate.instant('checkout.productoAdd'))
          }else{
            this.buyNow = false
            this.openCheckout()
          }
        } else {
          this.alerts.alertError(this.translate.instant('alerts.cantidadExcede'))
        }
        return;
      }
    }
    if (!exist) {
      this.cartService.addItemTocart(this.current_product, this.current_product, this.cantidad);
      if(!this.buyNow){
        this.alerts.alertToastCenter(this.translate.instant('checkout.productoAdd'))
      }else{
        this.buyNow = false
        this.openCheckout()
      }
    }
  }

  async openCheckout(): Promise<void> {
    const {CartModalComponent} = await import(
      '../../components/cartModal/cart-modal/cart-modal.component'
    );

    await this.modalService.open(CartModalComponent);
    this.modalService.nameComponent.next('CartModalComponent')
    this.checkoutService.setAbrirCheckout(true);
    // this.cartService.setShowCheckout(true)
  }




}
